import React, { useState, useEffect, useCallback } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode'

const CONTA = localStorage.getItem('idconta')
const LIMIT  = 50

const fmtMoeda = (v) => v != null ? Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '—'
const fmtData  = (unix) => unix ? new Date(unix * 1000).toLocaleDateString('pt-BR') : '—'

const STATUS_MAP = {
  NORMAL:  { color: '#16a34a', bg: '#dcfce7', label: 'Normal'   },
  BANNED:  { color: '#dc2626', bg: '#fee2e2', label: 'Banido'   },
  DELETED: { color: '#6b7280', bg: '#f3f4f6', label: 'Deletado' },
  UNLIST:  { color: '#d97706', bg: '#fef3c7', label: 'Inativo'  },
}

const css = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
  .shp-page{background:#f5f4f0;min-height:100vh;font-family:'DM Sans',sans-serif}
  .shp-header{background:#fff;border-bottom:1px solid #e8e4df;padding:20px 32px;display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;z-index:10}
  .shp-header-left{display:flex;align-items:center;gap:14px}
  .shp-header-icon{width:42px;height:42px;background:linear-gradient(135deg,#ee4d2d,#f97316);border-radius:12px;display:flex;align-items:center;justify-content:center;color:#fff;font-size:20px;box-shadow:0 4px 12px rgba(238,77,45,.3)}
  .shp-title{font-size:1.25rem;font-weight:700;color:#1a1a1a;margin:0}
  .shp-subtitle{font-size:.78rem;color:#9ca3af;margin:0}
  .shp-sync-btn{display:flex;align-items:center;gap:8px;background:linear-gradient(135deg,#ee4d2d,#f97316);color:#fff;border:none;border-radius:10px;padding:10px 20px;font-weight:600;font-size:.85rem;cursor:pointer;transition:all .2s;box-shadow:0 4px 14px rgba(238,77,45,.35);font-family:'DM Sans',sans-serif}
  .shp-sync-btn:hover{transform:translateY(-1px);box-shadow:0 6px 18px rgba(238,77,45,.45)}
  .shp-sync-btn:disabled{opacity:.6;cursor:not-allowed;transform:none}
  .shp-filters{padding:16px 32px;display:flex;gap:10px;flex-wrap:wrap;align-items:center}
  .shp-select,.shp-input{height:38px;border:1.5px solid #e8e4df;border-radius:9px;padding:0 12px;font-size:.83rem;font-family:'DM Sans',sans-serif;background:#fff;color:#1a1a1a;outline:none;transition:border-color .15s}
  .shp-select:focus,.shp-input:focus{border-color:#ee4d2d}
  .shp-input-wrap{position:relative;flex:1;min-width:220px;max-width:380px}
  .shp-input-wrap svg{position:absolute;left:11px;top:50%;transform:translateY(-50%);color:#9ca3af}
  .shp-input-wrap .shp-input{padding-left:34px;width:100%}
  .shp-input-wrap .shp-clear{position:absolute;right:10px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;color:#9ca3af;padding:0}
  .shp-clear-btn{height:38px;padding:0 16px;border:1.5px solid #e8e4df;border-radius:9px;background:#fff;font-size:.83rem;font-family:'DM Sans',sans-serif;cursor:pointer;color:#6b7280;transition:all .15s}
  .shp-clear-btn:hover{border-color:#ee4d2d;color:#ee4d2d}
  .shp-table-wrap{margin:0 32px 24px;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 1px 3px rgba(0,0,0,.06),0 4px 16px rgba(0,0,0,.04);border:1px solid #e8e4df}
  .shp-table{width:100%;border-collapse:collapse}
  .shp-table thead tr{background:#fafaf8;border-bottom:1px solid #e8e4df}
  .shp-table th{padding:11px 14px;font-size:.72rem;font-weight:600;color:#9ca3af;text-transform:uppercase;letter-spacing:.06em;white-space:nowrap}
  .shp-table tbody tr{border-bottom:1px solid #f3f0ec;transition:background .12s}
  .shp-table tbody tr:last-child{border-bottom:none}
  .shp-table tbody tr:hover{background:#fdf8f5}
  .shp-table td{padding:10px 14px;font-size:.83rem;color:#374151;vertical-align:middle}
  .shp-product-img{width:40px;height:40px;border-radius:10px;object-fit:cover;border:1px solid #f0ece8}
  .shp-product-img-ph{width:40px;height:40px;border-radius:10px;background:#f3f0ec;display:flex;align-items:center;justify-content:center;color:#d1c9c0;font-size:18px}
  .shp-name{font-weight:500;color:#111827;max-width:220px}
  .shp-name-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}
  .shp-brand{font-size:.74rem;color:#9ca3af;margin-top:1px}
  .shp-sku{font-family:'DM Mono',monospace;font-size:.76rem;color:#6b7280}
  .shp-status{display:inline-flex;align-items:center;gap:5px;padding:3px 10px;border-radius:20px;font-size:.74rem;font-weight:600}
  .shp-status::before{content:'';width:6px;height:6px;border-radius:50%;background:currentColor}
  .shp-stock{display:inline-flex;align-items:center;justify-content:center;min-width:28px;height:24px;padding:0 8px;border-radius:6px;font-weight:700;font-size:.8rem}
  .shp-price{font-weight:600;color:#111827;font-size:.88rem}
  .shp-price-old{font-size:.74rem;color:#9ca3af;text-decoration:line-through}
  .shp-tag{display:inline-block;padding:2px 8px;border-radius:5px;font-size:.72rem;font-weight:600}
  .shp-date{color:#9ca3af;font-size:.78rem}
  .shp-row-actions{display:flex;gap:4px;opacity:0;transition:opacity .15s}
  .shp-table tbody tr:hover .shp-row-actions{opacity:1}
  .shp-act-btn{width:28px;height:28px;border-radius:7px;border:1.5px solid #e8e4df;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:13px;transition:all .15s;color:#6b7280}
  .shp-act-btn:hover{border-color:#ee4d2d;color:#ee4d2d;background:#fff8f6}
  .shp-act-btn.danger:hover{border-color:#dc2626;color:#dc2626;background:#fff5f5}
  .shp-act-btn.ok:hover{border-color:#16a34a;color:#16a34a;background:#f0fdf4}
  .shp-act-btn.blue:hover{border-color:#2563eb;color:#2563eb;background:#eff6ff}
  .shp-act-btn:disabled{opacity:.4;cursor:not-allowed}
  .shp-modal-actions{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid #f0ece8}
  .shp-modal-act{display:flex;align-items:center;gap:6px;padding:8px 14px;border-radius:9px;border:1.5px solid #e8e4df;background:#fff;cursor:pointer;font-size:.82rem;font-weight:600;font-family:'DM Sans',sans-serif;color:#374151;transition:all .15s}
  .shp-modal-act:hover{border-color:#ee4d2d;color:#ee4d2d}
  .shp-modal-act.danger:hover{border-color:#dc2626;color:#dc2626}
  .shp-modal-act.ok:hover{border-color:#16a34a;color:#16a34a}
  .shp-modal-act.blue:hover{border-color:#2563eb;color:#2563eb}
  .shp-modal-act:disabled{opacity:.5;cursor:not-allowed}
  .shp-field-label{font-size:.75rem;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.05em;margin-bottom:5px}
  .shp-field-input{width:100%;height:40px;border:1.5px solid #e8e4df;border-radius:9px;padding:0 12px;font-size:.85rem;font-family:'DM Sans',sans-serif;outline:none;transition:border-color .15s}
  .shp-field-input:focus{border-color:#ee4d2d}
  .shp-field-textarea{width:100%;min-height:90px;border:1.5px solid #e8e4df;border-radius:9px;padding:10px 12px;font-size:.85rem;font-family:'DM Sans',sans-serif;outline:none;resize:vertical;transition:border-color .15s}
  .shp-field-textarea:focus{border-color:#ee4d2d}
  .shp-field-hint{font-size:.75rem;color:#9ca3af;margin-top:4px}
  .shp-pagination{padding:14px 32px;display:flex;align-items:center;justify-content:space-between}
  .shp-pag-info{font-size:.8rem;color:#9ca3af}
  .shp-pag-btns{display:flex;gap:4px}
  .shp-pag-btn{width:32px;height:32px;border-radius:8px;border:1.5px solid #e8e4df;background:#fff;font-size:.82rem;font-family:'DM Sans',sans-serif;cursor:pointer;color:#374151;transition:all .15s;display:flex;align-items:center;justify-content:center}
  .shp-pag-btn:hover:not(:disabled){border-color:#ee4d2d;color:#ee4d2d}
  .shp-pag-btn.active{background:#ee4d2d;border-color:#ee4d2d;color:#fff;font-weight:700}
  .shp-pag-btn:disabled{opacity:.35;cursor:not-allowed}
  .shp-modal-img{width:64px;height:64px;border-radius:10px;object-fit:cover;border:1px solid #f0ece8;cursor:pointer;transition:opacity .15s}
  .shp-modal-img:hover{opacity:.75}
  .shp-img-del{position:absolute;top:-6px;right:-6px;width:18px;height:18px;border-radius:50%;background:#dc2626;color:#fff;border:none;cursor:pointer;font-size:10px;display:flex;align-items:center;justify-content:center;line-height:1}
  .shp-img-add{width:64px;height:64px;border-radius:10px;border:1.5px dashed #e8e4df;background:#fafaf8;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:22px;color:#d1c9c0;transition:all .15s}
  .shp-img-add:hover{border-color:#ee4d2d;color:#ee4d2d}
  .shp-detail-row{display:flex;flex-wrap:wrap;gap:16px;margin-bottom:18px}
  .shp-detail-field{flex:1;min-width:110px}
  .shp-detail-label{font-size:.72rem;color:#9ca3af;font-weight:600;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px}
  .shp-detail-val{font-size:.88rem;color:#111827;font-weight:500}
  .shp-section-title{font-size:.72rem;font-weight:700;color:#9ca3af;text-transform:uppercase;letter-spacing:.07em;margin:18px 0 10px;display:flex;align-items:center;gap:6px}
  .shp-log-table{width:100%;border-collapse:collapse;font-size:.82rem}
  .shp-log-table th{padding:7px 10px;background:#fafaf8;color:#9ca3af;font-weight:600;font-size:.72rem;text-transform:uppercase;border-bottom:1px solid #f0ece8}
  .shp-log-table td{padding:8px 10px;border-bottom:1px solid #f8f5f2;color:#374151;vertical-align:middle}
  .shp-attr-pill{display:inline-flex;gap:4px;padding:4px 10px;border-radius:6px;background:#f8f5f2;border:1px solid #ede9e4;font-size:.78rem}
  .shp-attr-key{color:#9ca3af}
  .shp-attr-val{color:#1a1a1a;font-weight:500}
  .shp-var-badge{display:inline-block;padding:2px 8px;border-radius:5px;background:#f0f4ff;color:#3b5bdb;font-size:.72rem;font-weight:600}
  .shp-sync-modal-select{width:100%;height:42px;border:1.5px solid #e8e4df;border-radius:10px;padding:0 14px;font-size:.85rem;font-family:'DM Sans',sans-serif;background:#fff;color:#1a1a1a;outline:none;margin-top:6px}
  .shp-sync-modal-select:focus{border-color:#ee4d2d}
  .shp-modal-label{font-size:.78rem;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.05em}
  .shp-modal-hint{font-size:.76rem;color:#9ca3af;margin-top:5px}
  .shp-tog{display:inline-flex;align-items:center;gap:8px;cursor:pointer;font-size:.83rem;color:#374151}
  .shp-tog input{width:36px;height:20px;appearance:none;background:#e5e7eb;border-radius:10px;position:relative;cursor:pointer;transition:background .2s;outline:none}
  .shp-tog input::after{content:'';position:absolute;width:16px;height:16px;border-radius:50%;background:#fff;top:2px;left:2px;transition:left .2s;box-shadow:0 1px 3px rgba(0,0,0,.2)}
  .shp-tog input:checked{background:#ee4d2d}
  .shp-tog input:checked::after{left:18px}
  @keyframes fadeInUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
  .shp-table tbody tr{animation:fadeInUp .18s ease both}
  .shp-models-table{width:100%;border-collapse:collapse;font-size:.82rem;margin-top:4px}
  .shp-models-table th{padding:7px 10px;background:#fafaf8;color:#9ca3af;font-weight:600;font-size:.7rem;text-transform:uppercase;border-bottom:1px solid #f0ece8}
  .shp-models-table td{padding:8px 10px;border-bottom:1px solid #f8f5f2;vertical-align:middle}
  .shp-models-table tr:last-child td{border-bottom:none}
  .shp-model-edit-input{width:90px;height:30px;border:1.5px solid #e8e4df;border-radius:7px;padding:0 8px;font-size:.82rem;font-family:'DM Mono',monospace;outline:none;transition:border-color .15s}
  .shp-model-edit-input:focus{border-color:#ee4d2d}
  .shp-model-save-btn{height:28px;padding:0 10px;border-radius:7px;background:linear-gradient(135deg,#ee4d2d,#f97316);color:#fff;border:none;cursor:pointer;font-size:.76rem;font-weight:600;font-family:'DM Sans',sans-serif}
  .shp-model-save-btn:disabled{opacity:.45;cursor:not-allowed}
  .shp-confirm-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;display:flex;align-items:center;justify-content:center}
  .shp-confirm-box{background:#fff;border-radius:16px;padding:28px;max-width:400px;width:90%;box-shadow:0 20px 60px rgba(0,0,0,.2)}
  .shp-confirm-title{font-size:1rem;font-weight:700;color:#111827;margin-bottom:8px}
  .shp-confirm-msg{font-size:.85rem;color:#6b7280;margin-bottom:24px}
  .shp-confirm-btns{display:flex;gap:10px;justify-content:flex-end}
`

// ── Modal clone com atributos obrigatórios ────────────────────────────────────
function CloneModal({ show, onHide, item, lojaAtiva, onClone }) {
  const [step,      setStep]      = useState('loading')
  const [attrs,     setAttrs]     = useState([])   // todos obrigatórios da categoria
  const [selections,setSelections]= useState({})   // { [attribute_id]: { value_id, value_name } }
  const [itemName,  setItemName]  = useState('')
  const [cloning,   setCloning]   = useState(false)

  useEffect(() => {
    if (!show || !item) return
    setStep('loading')
    setSelections({})
    setAttrs([])
    apinode.get(`/itemshopee/clone-attrs/${CONTA}/${item.item_id}?idloja=${lojaAtiva}`)
      .then(({ data }) => {
        setItemName(data.item_name ?? item.item_name ?? '')
        setAttrs(data.missing_attrs ?? [])
        // se tem atributos obrigatórios faltando → mostra para preencher
        // se não tem → vai direto para confirmação
        setStep(data.missing_attrs?.length ? 'attrs' : 'confirm')
      })
      .catch(() => { toast.error('Erro ao buscar atributos'); onHide() })
  }, [show, item])

  const allSelected = attrs.every(a =>
    selections[a.attribute_id]?.value_id || selections[a.attribute_id]?.value_name
  )

  const handleClone = async () => {
    setCloning(true)
    const extra_attrs = attrs
      .filter(a => selections[a.attribute_id])
      .map(a => ({
        attribute_id:   a.attribute_id,
        attribute_name: a.attribute_name,
        value_id:       selections[a.attribute_id]?.value_id   ?? 0,
        value_name:     selections[a.attribute_id]?.value_name ?? '',
      }))
    await onClone(item, extra_attrs)
    setCloning(false)
  }

  const btnStyle = { padding:'9px 18px', border:'1.5px solid #e8e4df', borderRadius:9, background:'#fff', cursor:'pointer', fontFamily:'DM Sans', fontSize:'.85rem' }

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton style={{ borderBottom:'1px solid #f0ece8' }}>
        <Modal.Title style={{ fontFamily:'DM Sans', fontSize:'1rem', fontWeight:700 }}>🔁 Clonar item</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding:'20px 24px' }}>

        {step === 'loading' && (
          <div style={{ textAlign:'center', padding:'30px 0' }}>
            <Spinner animation="border" style={{ color:'#ee4d2d' }} />
            <div style={{ marginTop:10, color:'#9ca3af', fontSize:'.85rem' }}>Verificando atributos obrigatórios…</div>
          </div>
        )}

        {step === 'attrs' && (
          <>
            <div style={{ fontSize:'.85rem', color:'#374151', marginBottom:16 }}>
              Para clonar <strong>"{itemName?.slice(0,60)}"</strong>, preencha os atributos obrigatórios que estão faltando:
            </div>
            {attrs.map(attr => (
              <div key={attr.attribute_id} style={{ marginBottom:14 }}>
                <div className="shp-field-label">{attr.attribute_name} <span style={{ color:'#dc2626' }}>*</span></div>
                {attr.options?.length > 0
                  ? <select className="shp-select" style={{ width:'100%' }}
                      value={selections[attr.attribute_id]?.value_id ?? ''}
                      onChange={e => {
                        const opt = attr.options.find(o => String(o.value_id) === e.target.value)
                        if (opt) setSelections(s => ({ ...s, [attr.attribute_id]: { value_id: opt.value_id, value_name: opt.value_name } }))
                      }}>
                      <option value="">Selecione…</option>
                      {attr.options.map(o => <option key={o.value_id} value={o.value_id}>{o.value_name}</option>)}
                    </select>
                  : <input className="shp-field-input" placeholder="Digite o valor…"
                      value={selections[attr.attribute_id]?.value_name ?? ''}
                      onChange={e => setSelections(s => ({ ...s, [attr.attribute_id]: { value_id: 0, value_name: e.target.value } }))} />
                }
              </div>
            ))}
          </>
        )}

        {step === 'confirm' && (
          <div style={{ fontSize:'.85rem', color:'#374151' }}>
            Clonar <strong>"{itemName?.slice(0,60)}"</strong>?<br />
            <span style={{ color:'#9ca3af', fontSize:'.8rem' }}>Será criado um novo item com "(Cópia)" no nome.</span>
          </div>
        )}

        {cloning && (
          <div style={{ textAlign:'center', padding:'16px 0' }}>
            <Spinner animation="border" size="sm" style={{ color:'#ee4d2d' }} />
            <span style={{ marginLeft:8, color:'#9ca3af', fontSize:'.85rem' }}>Clonando…</span>
          </div>
        )}

      </Modal.Body>
      <Modal.Footer style={{ borderTop:'1px solid #f0ece8', gap:8 }}>
        <button onClick={onHide} style={btnStyle} disabled={cloning}>Cancelar</button>
        {step === 'attrs' && (
          <button className="shp-sync-btn" disabled={!allSelected || cloning} onClick={() => setStep('confirm')}>
            Próximo →
          </button>
        )}
        {step === 'confirm' && (
          <button className="shp-sync-btn" disabled={cloning} onClick={handleClone}>
            {cloning ? <><Spinner animation="border" size="sm" /> Clonando…</> : '🔁 Clonar'}
          </button>
        )}
      </Modal.Footer>
    </Modal>
  )
}

// ── Editor de atributos ──────────────────────────────────────────────────────
function AttrEditor({ detalhe, lojaAtiva, onSaved }) {
  const [catAttrs,   setCatAttrs]   = useState([])   // todos atributos da categoria
  const [values,     setValues]     = useState({})   // { [attribute_id]: { value_id, value_name } }
  const [loading,    setLoading]    = useState(false)
  const [saving,     setSaving]     = useState(false)

  useEffect(() => {
    if (!detalhe?.item_id || !lojaAtiva) return
    setLoading(true)

    // monta valores atuais do item
    const existing = {}
    ;(detalhe.attributes ?? []).forEach(a => {
      const id = a.attribute_id ?? a.ATTRIBUTE_ID
      existing[id] = {
        value_id:   a.value_id   ?? a.VALUE_ID   ?? 0,
        value_name: a.value_name ?? a.VALUE_NAME ?? '',
      }
    })

    // busca atributos da categoria
    apinode.get(`/itemshopee/clone-attrs/${CONTA}/${detalhe.item_id}?idloja=${lojaAtiva}`)
      .then(({ data }) => {
        // missing_attrs = atributos obrigatórios que faltam; precisamos de todos
        // por ora mostra o que já tem no item + os que faltam obrigatórios
        const allFromCategory = data.missing_attrs ?? []
        setCatAttrs(allFromCategory)
        setValues(existing)
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [detalhe?.item_id, lojaAtiva])

  const handleSave = async () => {
    setSaving(true)
    try {
      // monta attribute_list com os valores atuais do item + os novos preenchidos
      const existingAttrs = (detalhe.attributes ?? []).map(a => ({
        attribute_id: a.attribute_id ?? a.ATTRIBUTE_ID,
        attribute_value_list: [{
          value_id:            a.value_id   ?? a.VALUE_ID   ?? 0,
          original_value_name: a.value_name ?? a.VALUE_NAME ?? '',
          value_unit:          a.value_unit ?? a.VALUE_UNIT ?? '',
        }],
      }))

      // adiciona/sobrescreve com os editados da categoria
      const edited = catAttrs
        .filter(a => values[a.attribute_id]?.value_id || values[a.attribute_id]?.value_name)
        .map(a => ({
          attribute_id: a.attribute_id,
          attribute_value_list: [{
            value_id:            values[a.attribute_id]?.value_id ?? 0,
            original_value_name: values[a.attribute_id]?.value_name ?? '',
            value_unit:          '',
          }],
        }))

      const existingIds = new Set(edited.map(e => e.attribute_id))
      const merged = [...edited, ...existingAttrs.filter(a => !existingIds.has(a.attribute_id))]

      await apinode.post(`/itemshopee/update-attrs/${CONTA}`, {
        idloja:         lojaAtiva,
        item_id:        detalhe.item_id,
        attribute_list: merged,
      })
      toast.success('Atributos atualizados')
      onSaved?.()
    } catch(e) {
      toast.error(e?.response?.data?.message || 'Erro ao salvar atributos')
    } finally { setSaving(false) }
  }

  if (loading) return <div style={{ padding:'20px 0', textAlign:'center', color:'#9ca3af' }}><Spinner animation="border" size="sm" style={{ color:'#ee4d2d' }} /> Carregando atributos…</div>

  return (
    <div>
      {/* atributos já existentes no item */}
      {detalhe.attributes?.length > 0 && (
        <>
          <div className="shp-section-title" style={{ marginTop:0 }}>Atributos atuais</div>
          <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginBottom:18 }}>
            {detalhe.attributes.map((a, i) => (
              <span key={i} className="shp-attr-pill">
                <span className="shp-attr-key">{a.attribute_name ?? a.ATTRIBUTE_NAME}:</span>
                <span className="shp-attr-val">{a.value_name ?? a.VALUE_NAME}</span>
                {(a.is_mandatory || a.IS_MANDATORY) && <span style={{ color:'#dc2626', marginLeft:4 }}>*</span>}
              </span>
            ))}
          </div>
        </>
      )}

      {/* atributos obrigatórios faltantes para preencher */}
      {catAttrs.length > 0 && (
        <>
          <div className="shp-section-title">Atributos obrigatórios faltantes</div>
          {catAttrs.map(attr => (
            <div key={attr.attribute_id} style={{ marginBottom:14 }}>
              <div className="shp-field-label">
                {attr.attribute_name} <span style={{ color:'#dc2626' }}>*</span>
              </div>
              {attr.options?.length > 0
                ? <select className="shp-select" style={{ width:'100%' }}
                    value={values[attr.attribute_id]?.value_id ?? ''}
                    onChange={e => {
                      const opt = attr.options.find(o => String(o.value_id) === e.target.value)
                      if (opt) setValues(v => ({ ...v, [attr.attribute_id]: { value_id: opt.value_id, value_name: opt.value_name } }))
                    }}>
                    <option value="">Selecione…</option>
                    {attr.options.map(o => <option key={o.value_id} value={o.value_id}>{o.value_name}</option>)}
                  </select>
                : <input className="shp-field-input" placeholder="Digite o valor…"
                    value={values[attr.attribute_id]?.value_name ?? ''}
                    onChange={e => setValues(v => ({ ...v, [attr.attribute_id]: { value_id: 0, value_name: e.target.value } }))} />
              }
            </div>
          ))}
          <button className="shp-sync-btn" disabled={saving} onClick={handleSave} style={{ marginTop:8 }}>
            {saving ? <><Spinner animation="border" size="sm" /> Salvando…</> : '✓ Salvar atributos'}
          </button>
        </>
      )}

      {catAttrs.length === 0 && !detalhe.attributes?.length && (
        <div style={{ color:'#9ca3af', fontSize:'.83rem' }}>Nenhum atributo encontrado.</div>
      )}

      {catAttrs.length === 0 && detalhe.attributes?.length > 0 && (
        <div style={{ color:'#9ca3af', fontSize:'.8rem', marginTop:8 }}>
          Todos os atributos obrigatórios já estão preenchidos ✓
        </div>
      )}
    </div>
  )
}

// ── Confirm dialog ────────────────────────────────────────────────────────────
function ConfirmDialog({ msg, onConfirm, onCancel, loading, confirmLabel='Confirmar', danger=true }) {
  return (
    <div className="shp-confirm-overlay">
      <div className="shp-confirm-box">
        <div className="shp-confirm-title">Confirmação</div>
        <div className="shp-confirm-msg">{msg}</div>
        <div className="shp-confirm-btns">
          <button onClick={onCancel} style={{ padding:'9px 18px', border:'1.5px solid #e8e4df', borderRadius:9, background:'#fff', cursor:'pointer', fontFamily:'DM Sans', fontSize:'.85rem' }}>Cancelar</button>
          <button disabled={loading} onClick={onConfirm}
            style={{ padding:'9px 18px', borderRadius:9, border:'none', cursor:'pointer', fontFamily:'DM Sans', fontSize:'.85rem', fontWeight:600, background: danger ? '#dc2626' : 'linear-gradient(135deg,#ee4d2d,#f97316)', color:'#fff' }}>
            {loading ? <Spinner animation="border" size="sm" /> : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

// ── Modal de edição simples ───────────────────────────────────────────────────
function EditModal({ show, onHide, title, fields, onSave, saving }) {
  const [values, setValues] = useState({})
  useEffect(() => {
    if (show) { const init = {}; fields.forEach(f => { init[f.key] = f.initial ?? '' }); setValues(init) }
  }, [show])
  const set = (k, v) => setValues(prev => ({ ...prev, [k]: v }))
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton style={{ borderBottom:'1px solid #f0ece8' }}>
        <Modal.Title style={{ fontFamily:'DM Sans', fontSize:'1rem', fontWeight:700 }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding:'20px 24px' }}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))', gap:16 }}>
          {fields.map(f => (
            <div key={f.key} style={{ gridColumn: f.full ? '1/-1' : undefined }}>
              <div className="shp-field-label">{f.label}</div>
              {f.type === 'textarea'
                ? <textarea className="shp-field-textarea" value={values[f.key] ?? ''} onChange={e => set(f.key, e.target.value)} />
                : f.type === 'toggle'
                ? <label className="shp-tog"><input type="checkbox" checked={!!values[f.key]} onChange={e => set(f.key, e.target.checked)} />{values[f.key] ? 'Sim' : 'Não'}</label>
                : <input className="shp-field-input" type={f.type ?? 'text'} min={f.min} step={f.step} value={values[f.key] ?? ''} onChange={e => set(f.key, e.target.value)} />}
              {f.hint && <div className="shp-field-hint">{f.hint}</div>}
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop:'1px solid #f0ece8', gap:8 }}>
        <button onClick={onHide} style={{ padding:'9px 18px', border:'1.5px solid #e8e4df', borderRadius:9, background:'#fff', cursor:'pointer', fontFamily:'DM Sans', fontSize:'.85rem' }}>Cancelar</button>
        <button className="shp-sync-btn" disabled={saving} onClick={() => onSave(values)}>
          {saving ? <><Spinner animation="border" size="sm" /> Salvando…</> : '✓ Salvar'}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

// ── Gerenciador de imagens ────────────────────────────────────────────────────
function ImageManager({ images, onSave, idloja, saving }) {
  const [imgList, setImgList]   = useState(images ?? [])
  const [urlInput, setUrlInput] = useState('')
  const [uploading, setUploading] = useState(false)

  useEffect(() => { setImgList(images ?? []) }, [images])

  const addByUrl = async () => {
    if (!urlInput.trim()) return
    setUploading(true)
    try {
      const { data } = await apinode.post(`/itemshopee/upload-image/${CONTA}`, { idloja, image_url: urlInput.trim() })
      if (data.success && data.image_id) {
        setImgList(l => [...l, { image_id: data.image_id, image_url: data.image_url_list?.[0] ?? urlInput }])
        setUrlInput('')
        toast.success('Imagem adicionada')
      } else { toast.error('Erro ao fazer upload da imagem') }
    } catch { toast.error('Erro ao fazer upload') }
    finally { setUploading(false) }
  }

  const remove = (idx) => setImgList(l => l.filter((_, i) => i !== idx))

  return (
    <div>
      <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:12 }}>
        {imgList.map((img, i) => (
          <div key={i} style={{ position:'relative' }}>
            <img src={img.image_url ?? img.IMAGE_URL} className="shp-modal-img" alt="" />
            <button className="shp-img-del" onClick={() => remove(i)}>✕</button>
          </div>
        ))}
        {imgList.length < 9 && (
          <div className="shp-img-add" title="Adicionar imagem">＋</div>
        )}
      </div>
      <div style={{ display:'flex', gap:8, marginBottom:12 }}>
        <input className="shp-field-input" placeholder="URL da imagem para adicionar…" value={urlInput}
          onChange={e => setUrlInput(e.target.value)} style={{ flex:1 }} />
        <button className="shp-sync-btn" disabled={uploading || !urlInput} onClick={addByUrl} style={{ padding:'0 16px', height:40 }}>
          {uploading ? <Spinner animation="border" size="sm" /> : '＋ Upload'}
        </button>
      </div>
      <button className="shp-sync-btn" disabled={saving} onClick={() => onSave(imgList.map(i => i.image_id ?? i.IMAGE_ID))}>
        {saving ? <><Spinner animation="border" size="sm" /> Salvando…</> : '✓ Salvar imagens'}
      </button>
    </div>
  )
}

// ── Gerenciador de logística ──────────────────────────────────────────────────
function LogisticsEditor({ logistics, onSave, saving }) {
  const [list, setList] = useState(logistics ?? [])
  useEffect(() => { setList(logistics ?? []) }, [logistics])
  const toggle = (i, field) => setList(l => l.map((item, idx) => idx === i ? { ...item, [field]: !item[field] } : item))
  return (
    <div>
      <table className="shp-log-table" style={{ marginBottom:12 }}>
        <thead><tr><th>Transportadora</th><th style={{ textAlign:'center' }}>Habilitado</th><th style={{ textAlign:'center' }}>Grátis</th></tr></thead>
        <tbody>
          {list.map((l, i) => (
            <tr key={i}>
              <td>{l.logistic_name ?? l.LOGISTIC_NAME}</td>
              <td style={{ textAlign:'center' }}>
                <label className="shp-tog">
                  <input type="checkbox" checked={!!l.enabled ?? !!l.ENABLED} onChange={() => toggle(i,'enabled')} />
                </label>
              </td>
              <td style={{ textAlign:'center' }}>
                <label className="shp-tog">
                  <input type="checkbox" checked={!!l.is_free ?? !!l.IS_FREE} onChange={() => toggle(i,'is_free')} />
                </label>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button className="shp-sync-btn" disabled={saving} onClick={() => onSave(list.map(l => ({ logistic_id: l.logistic_id ?? l.LOGISTIC_ID, enabled: !!l.enabled, is_free: !!l.is_free })))}>
        {saving ? <><Spinner animation="border" size="sm" /> Salvando…</> : '✓ Salvar logística'}
      </button>
    </div>
  )
}

// ── Tabela de variações ───────────────────────────────────────────────────────
function ModelsTable({ models, loadingModels, onSaveModel, savingModel }) {
  const [edits, setEdits] = useState({})
  const set = (mid, field, val) => setEdits(e => ({ ...e, [mid]: { ...(e[mid]??{}), [field]: val } }))
  const get = (mid, field, fb) => edits[mid]?.[field] ?? fb

  if (loadingModels) return <div style={{ textAlign:'center', padding:'20px 0', color:'#9ca3af' }}><Spinner animation="border" size="sm" style={{ color:'#ee4d2d' }} /> Carregando variações…</div>
  if (!models?.length) return <div style={{ padding:'12px 0', color:'#9ca3af', fontSize:'.82rem' }}>Nenhuma variação encontrada.</div>

  return (
    <table className="shp-models-table">
      <thead><tr><th>Variação</th><th>SKU</th><th style={{ textAlign:'center' }}>Estoque</th><th style={{ textAlign:'right' }}>Preço atual</th><th style={{ textAlign:'right' }}>Novo preço</th><th style={{ textAlign:'center' }}>Novo estoque</th><th></th></tr></thead>
      <tbody>
        {models.map(m => {
          const mid   = m.model_id ?? m.MODEL_ID
          const name  = m.model_name ?? m.MODEL_NAME ?? `Model ${mid}`
          const sku   = m.seller_sku ?? m.SKU ?? '—'
          const stk   = m.stock_info?.[0]?.seller_stock?.[0]?.stock ?? m.STOCK ?? 0
          const price = m.price_info?.[0]?.current_price ?? m.CURR_PRICE ?? 0
          return (
            <tr key={mid}>
              <td><span style={{ fontWeight:500, color:'#111827' }}>{name}</span></td>
              <td><span className="shp-sku">{sku}</span></td>
              <td style={{ textAlign:'center' }}><span className="shp-stock" style={stk===0?{background:'#fee2e2',color:'#dc2626'}:{background:'#dcfce7',color:'#16a34a'}}>{stk}</span></td>
              <td style={{ textAlign:'right' }}><span className="shp-price">{fmtMoeda(price)}</span></td>
              <td style={{ textAlign:'right' }}><input className="shp-model-edit-input" type="number" min="0" step="0.01" placeholder={String(price)} value={get(mid,'price','')} onChange={e=>set(mid,'price',e.target.value)} /></td>
              <td style={{ textAlign:'center' }}><input className="shp-model-edit-input" type="number" min="0" placeholder={String(stk)} value={get(mid,'stock','')} onChange={e=>set(mid,'stock',e.target.value)} /></td>
              <td><button className="shp-model-save-btn" disabled={savingModel===String(mid)||(!edits[mid]?.price&&!edits[mid]?.stock)} onClick={()=>onSaveModel(mid,edits[mid])}>{savingModel===String(mid)?'…':'Salvar'}</button></td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

// ── Componente principal ──────────────────────────────────────────────────────
export default function ItemsShopee() {
  const [lojaFiltro, setLojaFiltro] = useState('')
  const [search,     setSearch]     = useState('')
  const [itemStatus, setItemStatus] = useState('')
  const [page,       setPage]       = useState(0)
  const [lojas,      setLojas]      = useState([])
  const [items,      setItems]      = useState([])
  const [total,      setTotal]      = useState(0)
  const [loading,    setLoading]    = useState(false)
  const [syncing,    setSyncing]    = useState(false)
  const [syncLoja,   setSyncLoja]   = useState('')
  const [showSync,   setShowSync]   = useState(false)
  const [detalhe,    setDetalhe]    = useState(null)
  const [loadingDet, setLoadingDet] = useState(false)
  const [acting,     setActing]     = useState({})
  const [editModal,  setEditModal]  = useState(null) // { type, item }
  const [saving,     setSaving]     = useState(false)
  const [models,        setModels]        = useState([])
  const [loadingModels, setLoadingModels] = useState(false)
  const [savingModel,   setSavingModel]   = useState(null)
  const [activeTab,  setActiveTab]  = useState('info')  // tab do modal detalhe
  const [confirm,    setConfirm]    = useState(null)    // { msg, onConfirm, danger, label }
  const [confirming, setConfirming] = useState(false)
  const [cloneItem,  setCloneItem]  = useState(null)   // item sendo clonado
  const [editAttrs,  setEditAttrs]  = useState(null)  // atributos editáveis da categoria
  const [loadingAttrs, setLoadingAttrs] = useState(false)
  const [savingAttrs,  setSavingAttrs]  = useState(false)

  // lojas
  useEffect(() => {
    apinode.get(`/listshopee/${CONTA}`).then(({ data }) => {
      const lista = (data.data ?? []).map(l => ({ id_conta: l.ID_CONTA??l.id_conta, apelido: l.APELIDO??l.apelido, shop_id: l.SHOP_ID??l.shop_id }))
      setLojas(lista)
      if (lista.length > 0) { setLojaFiltro(lista[0].id_conta); setSyncLoja(lista[0].id_conta) }
    }).catch(() => toast.error('Erro ao carregar lojas'))
  }, [])

  const lojaAtiva = lojas.find(l => l.id_conta === lojaFiltro)?.id_conta ?? lojas[0]?.id_conta ?? ''

  // itens
  const fetchItems = useCallback(async () => {
    setLoading(true)
    try {
      const p = new URLSearchParams({ limit: LIMIT, offset: page * LIMIT })
      if (search)     p.append('search',      search)
      if (itemStatus) p.append('item_status', itemStatus)
      const { data } = await apinode.get(`/itemshopee/items/${CONTA}?${p}`)
      setItems(data.data ?? [])
      setTotal(data.total ?? 0)
    } catch { toast.error('Erro ao buscar itens') }
    finally  { setLoading(false) }
  }, [search, itemStatus, page])

  useEffect(() => { fetchItems() }, [fetchItems])

  // detalhe
  const openDetalhe = async (item) => {
    setDetalhe({ _loading: true }); setLoadingDet(true); setModels([]); setActiveTab('info')
    try {
      const { data } = await apinode.get(`/itemshopee/items/${CONTA}/${item.item_id}`)
      setDetalhe(data.data)
      if (item.has_model || data.data?.has_model) {
        setLoadingModels(true)
        try {
          const r = await apinode.get(`/itemshopee/item-models/${CONTA}/${item.item_id}?idloja=${lojaAtiva}`)
          setModels(r.data.data?.model ?? [])
        } catch { toast.error('Erro ao carregar variações') }
        finally  { setLoadingModels(false) }
      }
    } catch { toast.error('Erro ao buscar detalhe'); setDetalhe(null) }
    finally  { setLoadingDet(false) }
  }

  // carrega atributos editáveis da categoria (todos, não só obrigatórios)
  const loadCategoryAttrs = async (item) => {
    if (!item?.category_id || !lojaAtiva) return
    setLoadingAttrs(true)
    try {
      const { data } = await apinode.get(`/itemshopee/clone-attrs/${CONTA}/${item.item_id}?idloja=${lojaAtiva}`)
      // busca todos os atributos da categoria (missing + os que já tem)
      const existing = {}
      ;(item.attributes ?? []).forEach(a => {
        existing[a.attribute_id ?? a.ATTRIBUTE_ID] = {
          value_id:   a.value_id   ?? a.VALUE_ID   ?? 0,
          value_name: a.value_name ?? a.VALUE_NAME ?? '',
        }
      })
      setEditAttrs({ categoryAttrs: data.missing_attrs ?? [], existing })
    } catch { toast.error('Erro ao carregar atributos da categoria') }
    finally { setLoadingAttrs(false) }
  }

  const reloadDetalhe = async (item_id) => {
    try {
      const { data } = await apinode.get(`/itemshopee/items/${CONTA}/${item_id}`)
      setDetalhe(data.data)
    } catch {}
  }

  // ação genérica
  const doAction = async (key, endpoint, body, successMsg) => {
    setActing(a => ({ ...a, [key]: true }))
    try {
      await apinode.post(`/itemshopee/${endpoint}/${CONTA}`, body)
      toast.success(successMsg)
      fetchItems()
      if (detalhe?.item_id === body.item_id) await reloadDetalhe(body.item_id)
    } catch (e) { toast.error(e?.response?.data?.message || 'Erro ao executar ação') }
    finally     { setActing(a => ({ ...a, [key]: false })) }
  }

  // salvar modal edição
  const handleSave = async (values) => {
    setSaving(true)
    const { type, item } = editModal
    try {
      if (type === 'price') {
        await doAction(`price_${item.item_id}`, 'update-price', { idloja: lojaAtiva, item_id: item.item_id, original_price: Number(values.price) }, `Preço atualizado para ${fmtMoeda(values.price)}`)
      } else if (type === 'stock') {
        await doAction(`stock_${item.item_id}`, 'update-stock', { idloja: lojaAtiva, item_id: item.item_id, stock: Number(values.stock) }, `Estoque atualizado para ${values.stock}`)
      } else if (type === 'info') {
        await doAction(`info_${item.item_id}`, 'update-info', {
          idloja:         lojaAtiva,
          item_id:        item.item_id,
          item_name:      values.item_name   || undefined,
          description:    values.description || undefined,
          item_sku:       values.item_sku    || undefined,
          weight:         values.weight      ? Number(values.weight)         : undefined,
          package_length: values.pkg_length  ? Number(values.pkg_length)     : undefined,
          package_width:  values.pkg_width   ? Number(values.pkg_width)      : undefined,
          package_height: values.pkg_height  ? Number(values.pkg_height)     : undefined,
          is_pre_order:   values.is_pre_order,
          days_to_ship:   values.days_to_ship ? Number(values.days_to_ship)  : undefined,
        }, 'Informações atualizadas')
      }
      setEditModal(null)
    } finally { setSaving(false) }
  }

  // salvar imagens
  const handleSaveImages = async (imageIdList) => {
    setSaving(true)
    try {
      await apinode.post(`/itemshopee/update-images/${CONTA}`, { idloja: lojaAtiva, item_id: detalhe.item_id, image_id_list: imageIdList })
      toast.success('Imagens atualizadas')
      await reloadDetalhe(detalhe.item_id)
      fetchItems()
    } catch { toast.error('Erro ao salvar imagens') }
    finally { setSaving(false) }
  }

  // salvar logística
  const handleSaveLogistics = async (logisticInfo) => {
    setSaving(true)
    try {
      await apinode.post(`/itemshopee/update-info/${CONTA}`, { idloja: lojaAtiva, item_id: detalhe.item_id, logistic_info: logisticInfo })
      toast.success('Logística atualizada')
      await reloadDetalhe(detalhe.item_id)
    } catch { toast.error('Erro ao salvar logística') }
    finally { setSaving(false) }
  }

  const toggleStatus = (item) => {
    const unlist = item.item_status === 'NORMAL'
    doAction(`status_${item.item_id}`, 'update-status', { idloja: lojaAtiva, item_id: item.item_id, unlist }, unlist ? 'Item inativado' : 'Item ativado')
  }

  // clonar — abre modal de atributos
  const handleClone = (item) => setCloneItem(item)

  const doClone = async (item, extra_attrs) => {
    try {
      const { data } = await apinode.post(`/itemshopee/clone/${CONTA}`, {
        idloja:      lojaAtiva,
        item_id:     item.item_id,
        extra_attrs: extra_attrs ?? [],
      })
      toast.success(`Item clonado! Novo ID: ${data.new_item_id}`)
      setCloneItem(null)
      fetchItems()
    } catch (e) { toast.error(e?.response?.data?.message || 'Erro ao clonar') }
  }

  // excluir
  const handleDelete = (item) => {
    setConfirm({
      msg:   `Excluir "${item.item_name?.slice(0,60)}" permanentemente da Shopee? Esta ação não pode ser desfeita.`,
      danger: true,
      label: 'Excluir',
      onConfirm: async () => {
        setConfirming(true)
        try {
          await apinode.post(`/itemshopee/delete/${CONTA}`, { idloja: lojaAtiva, item_id: item.item_id })
          toast.success('Item excluído')
          setConfirm(null)
          setDetalhe(null)
          fetchItems()
        } catch (e) { toast.error(e?.response?.data?.message || 'Erro ao excluir') }
        finally { setConfirming(false) }
      }
    })
  }

  // salvar variação
  const handleSaveModel = async (model_id, edits) => {
    if (!edits?.price && !edits?.stock) return
    setSavingModel(String(model_id))
    try {
      await apinode.post(`/itemshopee/update-model/${CONTA}`, { idloja: lojaAtiva, item_id: detalhe.item_id, model_id, ...(edits.price ? { original_price: Number(edits.price) } : {}), ...(edits.stock != null ? { stock: Number(edits.stock) } : {}) })
      toast.success('Variação atualizada')
      const r = await apinode.get(`/itemshopee/item-models/${CONTA}/${detalhe.item_id}?idloja=${lojaAtiva}`)
      setModels(r.data.data?.model ?? [])
      fetchItems()
    } catch { toast.error('Erro ao salvar variação') }
    finally  { setSavingModel(null) }
  }

  // sync
  const handleSync = async () => {
    if (!syncLoja) { toast.warn('Selecione a loja'); return }
    setSyncing(true)
    try {
      const { data } = await apinode.post(`/itemshopee/sync/${CONTA}`, { idloja: syncLoja })
      toast.success(`Sync concluído — ${data.inserted} inseridos, ${data.updated} atualizados`)
      setShowSync(false); fetchItems()
    } catch { toast.error('Erro ao sincronizar') }
    finally { setSyncing(false) }
  }

  // paginação
  const totalPages = Math.ceil(total / LIMIT) || 1
  const renderPagination = () => {
    if (totalPages <= 1) return null
    const btns = [], start = Math.max(0, page - 2), end = Math.min(totalPages - 1, page + 2)
    btns.push(<button key="prev" className="shp-pag-btn" disabled={page===0} onClick={()=>setPage(p=>p-1)}>‹</button>)
    if(start>0){btns.push(<button key={0} className="shp-pag-btn" onClick={()=>setPage(0)}>1</button>);if(start>1)btns.push(<button key="el1" className="shp-pag-btn" disabled>…</button>)}
    for(let i=start;i<=end;i++) btns.push(<button key={i} className={`shp-pag-btn${i===page?' active':''}`} onClick={()=>setPage(i)}>{i+1}</button>)
    if(end<totalPages-1){if(end<totalPages-2)btns.push(<button key="el2" className="shp-pag-btn" disabled>…</button>);btns.push(<button key={totalPages-1} className="shp-pag-btn" onClick={()=>setPage(totalPages-1)}>{totalPages}</button>)}
    btns.push(<button key="next" className="shp-pag-btn" disabled={page===totalPages-1} onClick={()=>setPage(p=>p+1)}>›</button>)
    return <div className="shp-pag-btns">{btns}</div>
  }

  const getSt = (s) => STATUS_MAP[s] ?? { color:'#6b7280', bg:'#f3f4f6', label: s??'—' }
  const getSk = (q) => q===0 ? { bg:'#fee2e2',color:'#dc2626' } : q<=3 ? { bg:'#fef3c7',color:'#d97706' } : { bg:'#dcfce7',color:'#16a34a' }

  const ActionButtons = ({ item, compact=false }) => {
    const isA      = (k) => acting[`${k}_${item.item_id}`]
    const unlisted = item.item_status === 'UNLIST'
    if (compact) return (
      <div className="shp-row-actions" onClick={e=>e.stopPropagation()}>
        <button title="Editar preço"   className="shp-act-btn" disabled={isA('price')}  onClick={()=>setEditModal({type:'price',item})}>{isA('price')?'…':'💲'}</button>
        <button title="Editar estoque" className="shp-act-btn" disabled={isA('stock')}  onClick={()=>setEditModal({type:'stock',item})}>{isA('stock')?'…':'📦'}</button>
        <button title="Editar info"    className="shp-act-btn" disabled={isA('info')}   onClick={()=>setEditModal({type:'info',item})}>{isA('info')?'…':'✏️'}</button>
        <button title="Clonar"         className="shp-act-btn blue"                     onClick={()=>handleClone(item)}>🔁</button>
        <button title={unlisted?'Ativar':'Inativar'} className={`shp-act-btn ${unlisted?'ok':'danger'}`} disabled={isA('status')} onClick={()=>toggleStatus(item)}>{isA('status')?'…':unlisted?'✅':'🚫'}</button>
        <button title="Excluir"        className="shp-act-btn danger"                   onClick={()=>handleDelete(item)}>🗑</button>
      </div>
    )
    return (
      <div className="shp-modal-actions">
        {[
          {key:'price', icon:'💲', label:'Editar preço',    onClick:()=>setEditModal({type:'price',item})},
          {key:'stock', icon:'📦', label:'Editar estoque',   onClick:()=>setEditModal({type:'stock',item})},
          {key:'info',  icon:'✏️', label:'Editar detalhes',  onClick:()=>setEditModal({type:'info',item})},
        ].map(a=>(
          <button key={a.key} className="shp-modal-act" disabled={isA(a.key)} onClick={a.onClick}>
            {isA(a.key)?<Spinner animation="border" size="sm"/>:a.icon} {a.label}
          </button>
        ))}
        <button className="shp-modal-act blue" onClick={()=>handleClone(item)}>🔁 Clonar</button>
        <button className={`shp-modal-act ${unlisted?'ok':'danger'}`} disabled={isA('status')} onClick={()=>toggleStatus(item)}>
          {isA('status')?<Spinner animation="border" size="sm"/>:unlisted?'✅':'🚫'} {unlisted?'Ativar':'Inativar'}
        </button>
        <button className="shp-modal-act danger" onClick={()=>handleDelete(item)}>🗑 Excluir</button>
      </div>
    )
  }

  const btnStyle = { padding:'9px 18px', border:'1.5px solid #e8e4df', borderRadius:9, background:'#fff', cursor:'pointer', fontFamily:'DM Sans', fontSize:'.85rem' }

  // tabs do modal detalhe
  const TABS = [
    { id:'info',      label:'📋 Informações' },
    { id:'images',    label:'🖼 Imagens'     },
    { id:'logistics', label:'🚚 Logística'   },
    { id:'variants',  label:'🎨 Variações'   },
    { id:'attrs',     label:'🏷 Atributos'   },
  ]

  return (
    <>
      <style>{css}</style>
      <Navbar />
      <ToastContainer position="top-right" autoClose={3000} />
      {cloneItem && <CloneModal show={!!cloneItem} onHide={()=>setCloneItem(null)} item={cloneItem} lojaAtiva={lojaAtiva} onClone={doClone} />}
      {confirm && <ConfirmDialog msg={confirm.msg} danger={confirm.danger} confirmLabel={confirm.label} loading={confirming} onConfirm={confirm.onConfirm} onCancel={()=>setConfirm(null)} />}

      <div className="shp-page">
        {/* header */}
        <div className="shp-header">
          <div className="shp-header-left">
            <div className="shp-header-icon">🛍</div>
            <div>
              <p className="shp-title">Itens Shopee</p>
              <p className="shp-subtitle">{total > 0 ? `${total} itens encontrados` : 'Nenhum item'}</p>
            </div>
          </div>
          <button className="shp-sync-btn" onClick={()=>setShowSync(true)}>⟳ Sincronizar Shopee</button>
        </div>

        {/* filtros */}
        <div className="shp-filters">
          <select className="shp-select" style={{ minWidth:160 }} value={lojaFiltro} onChange={e=>{setLojaFiltro(e.target.value);setPage(0)}}>
            <option value="">Todas as lojas</option>
            {lojas.map(l=><option key={l.id_conta} value={l.id_conta}>{l.apelido||l.id_conta}</option>)}
          </select>
          <div className="shp-input-wrap">
            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
            <input className="shp-input" placeholder="Buscar por nome ou SKU…" value={search} onChange={e=>{setSearch(e.target.value);setPage(0)}} />
            {search && <button className="shp-clear" onClick={()=>{setSearch('');setPage(0)}}>✕</button>}
          </div>
          <select className="shp-select" style={{ minWidth:140 }} value={itemStatus} onChange={e=>{setItemStatus(e.target.value);setPage(0)}}>
            <option value="">Todos os status</option>
            <option value="NORMAL">Normal</option>
            <option value="BANNED">Banido</option>
            <option value="DELETED">Deletado</option>
            <option value="UNLIST">Inativo</option>
          </select>
          <button className="shp-clear-btn" onClick={()=>{setSearch('');setItemStatus('');setLojaFiltro('');setPage(0)}}>Limpar</button>
        </div>

        {/* tabela */}
        <div className="shp-table-wrap">
          <table className="shp-table">
            <thead>
              <tr>
                <th style={{ width:52 }}></th>
                <th>Produto</th><th>SKU</th><th>Status</th>
                <th style={{ textAlign:'center' }}>Estoque</th>
                <th style={{ textAlign:'right' }}>Preço</th>
                <th style={{ textAlign:'center' }}>Variações</th>
                <th style={{ textAlign:'center' }}>Promoção</th>
                <th>Atualização</th>
                <th style={{ width:160 }}></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={10} style={{ padding:'56px 0', textAlign:'center', color:'#9ca3af' }}>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10 }}>
                    <Spinner animation="border" size="sm" style={{ color:'#ee4d2d' }} /><span>Carregando itens…</span>
                  </div>
                </td></tr>
              ) : items.length === 0 ? (
                <tr><td colSpan={10} style={{ padding:'56px 0', textAlign:'center', color:'#9ca3af' }}>
                  <div style={{ fontSize:'2rem', marginBottom:8, opacity:.4 }}>📦</div>
                  <div style={{ fontWeight:500 }}>Nenhum item encontrado</div>
                </td></tr>
              ) : items.map((item, idx) => {
                const st=getSt(item.item_status), sk=getSk(item.stock_available??0)
                return (
                  <tr key={item.item_id} style={{ animationDelay:`${idx*0.03}s`, cursor:'pointer' }} onClick={()=>openDetalhe(item)}>
                    <td style={{ paddingLeft:14 }}>{item.image_url?<img src={item.image_url} className="shp-product-img" alt=""/>:<div className="shp-product-img-ph">📷</div>}</td>
                    <td><div className="shp-name"><span className="shp-name-text" title={item.item_name}>{item.item_name}</span>{item.brand_name&&<span className="shp-brand">{item.brand_name}</span>}</div></td>
                    <td><span className="shp-sku">{item.item_sku||'—'}</span></td>
                    <td><span className="shp-status" style={{ color:st.color,background:st.bg }}>{st.label}</span></td>
                    <td style={{ textAlign:'center' }}><span className="shp-stock" style={{ background:sk.bg,color:sk.color }}>{item.stock_available??0}</span></td>
                    <td style={{ textAlign:'right' }}>
                      {item.curr_price!=null?<div><div className="shp-price">{fmtMoeda(item.curr_price)}</div>{item.orig_price&&item.orig_price!==item.curr_price&&<div className="shp-price-old">{fmtMoeda(item.orig_price)}</div>}</div>:<span style={{ color:'#d1c9c0' }}>—</span>}
                    </td>
                    <td style={{ textAlign:'center' }}>{item.has_model?<span className="shp-var-badge">Com var.</span>:<span style={{ color:'#d1c9c0' }}>—</span>}</td>
                    <td style={{ textAlign:'center' }}>{item.has_promotion?<span className="shp-tag" style={{ background:'#fee2e2',color:'#dc2626' }}>Sim</span>:<span style={{ color:'#d1c9c0' }}>—</span>}</td>
                    <td><span className="shp-date">{fmtData(item.update_time)}</span></td>
                    <td onClick={e=>e.stopPropagation()}><ActionButtons item={item} compact /></td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        <div className="shp-pagination">
          <span className="shp-pag-info">Página {page+1} de {totalPages}</span>
          {renderPagination()}
        </div>
      </div>

      {/* Modal Sync */}
      <Modal show={showSync} onHide={()=>setShowSync(false)} centered>
        <Modal.Header closeButton style={{ borderBottom:'1px solid #f0ece8' }}>
          <Modal.Title style={{ fontFamily:'DM Sans', fontSize:'1rem', fontWeight:700 }}>Sincronizar com a Shopee</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding:'20px 24px' }}>
          <div className="shp-modal-label">Loja Shopee</div>
          <select className="shp-sync-modal-select" value={syncLoja} onChange={e=>setSyncLoja(e.target.value)}>
            <option value="">Selecione a loja…</option>
            {lojas.map(l=><option key={l.id_conta} value={l.id_conta}>{l.apelido||l.id_conta}{l.shop_id?` — ${l.shop_id}`:''}</option>)}
          </select>
          <p className="shp-modal-hint">Buscará todos os itens ativos da loja e salvará no banco.</p>
        </Modal.Body>
        <Modal.Footer style={{ borderTop:'1px solid #f0ece8', gap:8 }}>
          <button onClick={()=>setShowSync(false)} style={btnStyle}>Cancelar</button>
          <button className="shp-sync-btn" disabled={syncing||!syncLoja} onClick={handleSync}>
            {syncing?<><Spinner animation="border" size="sm"/> Sincronizando…</>:<>⟳ Sincronizar</>}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Modal Detalhe */}
      <Modal show={!!detalhe} onHide={()=>{setDetalhe(null);setModels([])}} size="xl" centered>
        <Modal.Header closeButton style={{ borderBottom:'1px solid #f0ece8' }}>
          <Modal.Title style={{ fontFamily:'DM Sans', fontSize:'1rem', fontWeight:700, maxWidth:540, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
            {detalhe?.item_name ?? '…'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding:'20px 24px' }}>
          {loadingDet ? (
            <div style={{ textAlign:'center', padding:'40px 0' }}><Spinner animation="border" style={{ color:'#ee4d2d' }} /></div>
          ) : detalhe && !detalhe._loading && (
            <>
              <ActionButtons item={detalhe} compact={false} />

              {/* tabs */}
              <div style={{ display:'flex', gap:4, borderBottom:'1px solid #f0ece8', marginBottom:20 }}>
                {TABS.map(t => (
                  <button key={t.id} onClick={()=>setActiveTab(t.id)}
                    style={{ padding:'8px 14px', border:'none', background:'none', cursor:'pointer', fontFamily:'DM Sans', fontSize:'.82rem', fontWeight: activeTab===t.id ? 700 : 400, color: activeTab===t.id ? '#ee4d2d' : '#6b7280', borderBottom: activeTab===t.id ? '2px solid #ee4d2d' : '2px solid transparent', marginBottom:-1 }}>
                    {t.label}
                  </button>
                ))}
              </div>

              {/* tab: info */}
              {activeTab === 'info' && (
                <>
                  <div className="shp-detail-row">
                    {[
                      { label:'SKU',     val:<code style={{ fontFamily:'DM Mono', fontSize:'.85rem' }}>{detalhe.item_sku||'—'}</code> },
                      { label:'Status',  val:(()=>{const s=getSt(detalhe.item_status);return <span className="shp-status" style={{ color:s.color,background:s.bg }}>{s.label}</span>})() },
                      { label:'Estoque', val:(()=>{const s=getSk(detalhe.stock_available??0);return <><span className="shp-stock" style={{ background:s.bg,color:s.color }}>{detalhe.stock_available??0}</span>{detalhe.stock_reserved>0&&<span style={{ fontSize:'.76rem',color:'#9ca3af',marginLeft:6 }}>({detalhe.stock_reserved} reservado)</span>}</>})() },
                      { label:'Marca',   val: detalhe.brand_name||'—' },
                      { label:'Peso',    val: detalhe.weight ? `${detalhe.weight} kg` : '—' },
                      { label:'Dimensões', val: detalhe.pkg_length ? `${detalhe.pkg_length}×${detalhe.pkg_width}×${detalhe.pkg_height} cm` : '—' },
                      { label:'Pré-venda', val: detalhe.is_pre_order ? `Sim (${detalhe.days_to_ship}d)` : 'Não' },
                    ].map(f=>(
                      <div key={f.label} className="shp-detail-field">
                        <div className="shp-detail-label">{f.label}</div>
                        <div className="shp-detail-val">{f.val}</div>
                      </div>
                    ))}
                  </div>

                  {/* preços item simples */}
                  {!detalhe.has_model && detalhe.prices?.length > 0 && (
                    <>
                      <div className="shp-section-title">💰 Preços</div>
                      {detalhe.prices.map((p,i)=>(
                        <div key={i} style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:'1px solid #f8f5f2' }}>
                          <span style={{ color:'#9ca3af', fontSize:'.83rem' }}>{p.currency}</span>
                          <span>{p.orig_price!==p.curr_price&&<span className="shp-price-old" style={{ marginRight:8 }}>{fmtMoeda(p.orig_price)}</span>}<span className="shp-price" style={{ color:'#16a34a' }}>{fmtMoeda(p.curr_price)}</span></span>
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}

              {/* tab: images */}
              {activeTab === 'images' && (
                <ImageManager images={detalhe.images} onSave={handleSaveImages} idloja={lojaAtiva} saving={saving} />
              )}

              {/* tab: logistics */}
              {activeTab === 'logistics' && (
                <LogisticsEditor logistics={detalhe.logistics} onSave={handleSaveLogistics} saving={saving} />
              )}

              {/* tab: variants */}
              {activeTab === 'variants' && (
                <ModelsTable models={models} loadingModels={loadingModels} onSaveModel={handleSaveModel} savingModel={savingModel} />
              )}

              {/* tab: attrs */}
              {activeTab === 'attrs' && (
                <AttrEditor
                  detalhe={detalhe}
                  lojaAtiva={lojaAtiva}
                  onSaved={async () => { await reloadDetalhe(detalhe.item_id) }}
                />
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer style={{ borderTop:'1px solid #f0ece8' }}>
          <button onClick={()=>{setDetalhe(null);setModels([])}} style={btnStyle}>Fechar</button>
        </Modal.Footer>
      </Modal>

      {/* Modal edição */}
      {editModal && (
        <EditModal
          show={!!editModal}
          onHide={()=>setEditModal(null)}
          saving={saving}
          onSave={handleSave}
          title={
            editModal.type==='price' ? `Editar preço — ${editModal.item.item_name?.slice(0,40)}` :
            editModal.type==='stock' ? `Editar estoque — ${editModal.item.item_name?.slice(0,40)}` :
            `Editar detalhes — ${editModal.item.item_name?.slice(0,40)}`
          }
          fields={
            editModal.type==='price' ? [{ key:'price', label:'Novo preço (R$)', type:'number', min:0, step:'0.01', initial:editModal.item.curr_price??'', hint:'Valor sem formatação' }] :
            editModal.type==='stock' ? [{ key:'stock', label:'Novo estoque', type:'number', min:0, initial:editModal.item.stock_available??0 }] :
            [
              { key:'item_name',   label:'Nome do item',   type:'text',     initial:editModal.item.item_name??'',    hint:'Máx. 120 caracteres', full:true },
              { key:'description', label:'Descrição',      type:'textarea', initial:editModal.item.description??'',  full:true },
              { key:'item_sku',    label:'SKU',            type:'text',     initial:editModal.item.item_sku??'' },
              { key:'weight',      label:'Peso (kg)',       type:'number',   initial:editModal.item.weight??'',       step:'0.001', min:0 },
              { key:'pkg_length',  label:'Comprimento (cm)',type:'number',   initial:editModal.item.pkg_length??'',   min:0 },
              { key:'pkg_width',   label:'Largura (cm)',    type:'number',   initial:editModal.item.pkg_width??'',    min:0 },
              { key:'pkg_height',  label:'Altura (cm)',     type:'number',   initial:editModal.item.pkg_height??'',   min:0 },
              { key:'is_pre_order',label:'Pré-venda',       type:'toggle',   initial:!!editModal.item.is_pre_order },
              { key:'days_to_ship',label:'Dias para envio', type:'number',   initial:editModal.item.days_to_ship??3,  min:1 },
            ]
          }
        />
      )}
    </>
  )
}